import { request } from '@services'
import { STATUS_REQUEST } from '@utils/constant'

export const state = {
  memberDetails: {},
  status: null,
  loading: false,
  errors: null,
}

export const getters = {
  getMemberDetails(state) {
    return state.memberDetails
  },
  getStatus(state) {
    return state.status
  },
  getErrors(state) {
    return state.errors
  },
}

export const mutations = {
  SET_MEMBER_DETAILS_REQUESTED(state) {
    state.loading = true
  },
  SET_MEMBER_DETAILS_RECEIVED(state, newData) {
    state.loading = false
    state.memberDetails = newData
    state.errors = null
  },
  SET_MEMBER_DETAILS_RECEIVED_FAIL(state, error) {
    state.loading = false
    state.errors = error
  },
  SET_MEMBER_EDIT_REQUESTED(state) {
    state.loading = true
  },
  SET_MEMBER_EDIT_RECEIVED(state) {
    state.loading = false
    state.status = STATUS_REQUEST.SUCCESS
    state.errors = null
  },
  SET_MEMBER_EDIT_FAILED(state, errors) {
    state.loading = false
    state.status = STATUS_REQUEST.FAILED
    state.errors = errors
  },
  RESET_MEMBER_EDIT_FAILED(state) {
    state.loading = false
    state.status = null
    state.errors = null
  },
}

export const actions = {
  async fetchingMemberDetails({ commit }, payload) {
    commit('SET_MEMBER_DETAILS_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/member/get/',
        payload: {
          ...payload,
        },
      })
      commit('SET_MEMBER_DETAILS_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_MEMBER_DETAILS_RECEIVED_FAIL', error)
    }
  },
  async editMember({ commit }, params) {
    commit('SET_MEMBER_EDIT_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/member/edit/',
        payload: {
          ...params,
        },
      })
      commit('SET_MEMBER_EDIT_RECEIVED')
      return response
    } catch (error) {
      commit('SET_MEMBER_EDIT_FAILED', error)
    }
  },
  resetMemberEdit({ commit }) {
    commit('RESET_MEMBER_EDIT_FAILED')
  },
}
